module.exports = __webpack_public_path__ + "img/programok2.fb3931b1.png";